// פונקציות עזר משותפות לחישוב זמני כניסת/יציאת שבת
// משמשות גם את ShabbatWidget וגם את ZmanimWidget לסנכרון הזמנים

const addMinsToTime = (base, offsetMins) => {
  if (!base || !base.match(/^\d{2}:\d{2}$/)) return null;
  const [h, m] = base.split(':').map(Number);
  let total = h * 60 + m + offsetMins;
  total = ((total % 1440) + 1440) % 1440;
  return `${String(Math.floor(total / 60)).padStart(2,'0')}:${String(total % 60).padStart(2,'0')}`;
};

/**
 * מחשב את זמן כניסת שבת לפי הגדרת entryZman.
 * @param {object} shabbat - אובייקט נתוני השבת (meta, friday, shabbat)
 * @param {object|null} entryZman - הגדרת זמן הכניסה מהקונפיגורציה
 * @returns {string|null} זמן בפורמט HH:MM
 */
export const computeShabbatEntryTime = (shabbat, entryZman) => {
  const ez = entryZman;
  if (ez?.key === 'sunset' && shabbat?.friday?.sunset) {
    return addMinsToTime(shabbat.friday.sunset, -(Number(ez.minsBeforeSunset) || 0));
  }
  if (ez?.key === 'plagHamincha' && shabbat?.friday?.plagHamincha) {
    return addMinsToTime(shabbat.friday.plagHamincha, Number(ez.offset) || 0);
  }
  return shabbat?.meta?.candleLighting || null;
};

/**
 * מחשב את זמן יציאת שבת לפי הגדרת exitZman.
 * @param {object} shabbat - אובייקט נתוני השבת (meta, friday, shabbat)
 * @param {object|null} exitZman - הגדרת זמן היציאה מהקונפיגורציה
 * @returns {string|null} זמן בפורמט HH:MM
 */
export const computeShabbatExitTime = (shabbat, exitZman) => {
  const xz = exitZman;
  const key = xz?.key || 'tzeit85deg';
  const base = shabbat?.shabbat?.[key];
  if (!base) return shabbat?.shabbat?.havdalah || shabbat?.meta?.havdalah || null;
  const offset = Number(xz?.offset) || 0;
  return offset === 0 ? base : addMinsToTime(base, offset);
};
